import { Divider, Flex, Image, Text } from '@chakra-ui/react';
import DenimHealthTextLogo from '../../assets/logo/denim-health-logo-light-ui.svg';
import { LoginButton, LoginWithPasswordButton } from '../auth/Login';
import { Link as RouterLink } from 'react-router-dom';
const LoginPage: React.FC = () => {
  return (
    <Flex
      height="100vh"
      background="blue.700"
      justifyContent="center"
      alignItems="center"
      padding="10.625rem 0rem 21.8125rem 0rem"
    >
      <Flex
        p="2rem"
        background="#fff"
        borderRadius="0.75rem"
        border="1px solid"
        borderColor="#E5E7EB"
        boxShadow="0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)"
        flexDirection="column"
      >
        <Flex justify="center">
          <Image
            src={DenimHealthTextLogo}
            alt="Denim Health Logo"
            mb="2rem"
            maxWidth="8.19rem"
            maxHeight="1.5rem"
          />
        </Flex>
        <LoginButton />
        <LoginWithPasswordButton mt="0.75rem" />
        <Divider mt="1rem" width="20.8rem" />
        <Flex mt="1rem" justify="center">
          <Text
            color="#4D5761"
            fontSize="0.875rem"
            fontWeight="400"
            lineHeight="1.125rem"
            letterSpacing="0.00875rem"
          >
            View our
          </Text>
          <RouterLink to="/privacy-policy">
            <Text
              color="#1C3FA0"
              fontWeight="600"
              fontSize="0.875rem"
              lineHeight="1.125rem"
              letterSpacing="0.00875rem"
              ml="0.25rem"
              cursor="pointer"
            >
              privacy policy
            </Text>
          </RouterLink>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default LoginPage;
